import { apiSlice } from "../../../app/api/apiSlice";

export const amPipelineSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getAmPipeline: builder.mutation({
			query: () => ({
				url: `/api/v1/admin/internal_users_pipeline/AM/`,
				method: "GET",
			}),
		}),
	}),
});

export const { useGetAmPipelineMutation } = amPipelineSlice;
